/**
 * Labstep
 *
 * @module core/Logo
 * @desc Logo component
 */

import type React from 'react';
import { Image } from 'semantic-ui-react';
import type { ILogoProps } from './types';

/**
 * Logo component
 * @return An image of Labstep logo
 */
export const Logo: React.FC<ILogoProps> = ({
  simplified,
  size,
  blue,
  ...rest
}) => {
  let logo = 'logo';

  if (simplified) {
    logo = 'logo-simplified';
  }

  if (blue) {
    logo = 'logo-blue';
  }

  return (
    <Image size={size} src={`/img/logo/${logo}.svg`} {...rest} />
  );
};
